import { InvoiceData } from '@sky-distribution/adapter-core-pc-rest-interfaces';

export const billingPeriods: InvoiceData[] = [
  {
    billingPeriodicity: 'everyyear',
    downPayment: {
      amount: 200.0,
      currency: 'pln',
    },
    id: 'BC_BASE:4',
    installments: [],
    name: 'Lump Sum Payment Plan',
    selected: true,
    total: {
      amount: 200.0,
      currency: 'pln',
    },
  },
  {
    billingPeriodicity: 'everysixmonths',
    downPayment: {
      amount: 150.0,
      currency: 'pln',
    },
    id: 'BC_BASE:7',
    installments: [],
    name: '2 Installments Payment Plan',
    selected: false,
    total: {
      amount: 150.0,
      currency: 'pln',
    },
  },
];
